<script setup>
import { ref, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import TemplatesPicker from './TemplatesPicker.vue';
import WhatsAppTemplateReply from './WhatsAppTemplateReply.vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

defineProps({
  inboxId: {
    type: Number,
    default: undefined,
  },
});

const emit = defineEmits(['onSend', 'cancel']);

const { t } = useI18n();

const dialogRef = ref(null);
const selectedWaTemplate = ref(null);

const modalHeaderContent = computed(() => {
  return selectedWaTemplate.value
    ? t('WHATSAPP_TEMPLATES.MODAL.TEMPLATE_SELECTED_SUBTITLE', {
        templateName: selectedWaTemplate.value.name,
      })
    : t('WHATSAPP_TEMPLATES.MODAL.SUBTITLE');
});

onMounted(() => {
  dialogRef.value?.open();
});

const pickTemplate = template => {
  selectedWaTemplate.value = template;
};

const onResetTemplate = () => {
  selectedWaTemplate.value = null;
};

const onSendMessage = message => {
  emit('onSend', message);
};

const onClose = () => {
  emit('cancel');
};
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="2xl"
    overflow-y-auto
    :title="$t('WHATSAPP_TEMPLATES.MODAL.TITLE')"
    :description="modalHeaderContent"
    :show-cancel-button="false"
    :show-confirm-button="false"
    @close="onClose"
  >
    <TemplatesPicker
      v-if="!selectedWaTemplate"
      :inbox-id="inboxId"
      @on-select="pickTemplate"
    />
    <WhatsAppTemplateReply
      v-else
      :template="selectedWaTemplate"
      @reset-template="onResetTemplate"
      @send-message="onSendMessage"
    />
    <template #footer />
  </Dialog>
</template>
